<template>
  <div class="sat-menu router-menu">
    <div v-if="routers.length > 7" class="router-menu__search">
      <SatIcon name="search" :size="14" />
      <input ref="search" v-model.trim="query" type="text" :placeholder="$t('satellites.routers.search')" @keydown.enter.prevent="pickFirst" />
    </div>
    <div class="sat-menu__label">{{ $t("satellites.routers.pick") }}</div>
    <button v-for="router in filtered" :key="router.id" type="button" class="sat-menu__item" :class="{ _active: router.id === value }" @click="$emit('select', router.id)">
      <span class="sat-menu__check"><SatIcon v-if="router.id === value" name="check" :size="14" /></span>
      <span class="router-menu__name">{{ router.name }}</span>
      <span class="sat-menu__meta">{{ pl("satellites.counts.routes", router.routes.length) }}</span>
    </button>
    <div v-if="!filtered.length" class="router-menu__empty">{{ routers.length ? $t("satellites.routers.nothing_found") : $t("satellites.routers.none_yet") }}</div>
    <div class="sat-menu__divider"></div>
    <button v-if="allowNone" type="button" class="sat-menu__item" :class="{ _active: value === null }" @click="$emit('select', null)">
      <span class="sat-menu__check"><SatIcon v-if="value === null" name="check" :size="14" /></span>
      {{ $t("satellites.routers.no_router") }}
    </button>
    <router-link :to="{ name: 'SatelliteRouters', query: { create: '1' } }" class="sat-menu__item">
      <span class="sat-menu__check"><SatIcon name="plus" :size="14" /></span>
      {{ $t("satellites.routers.create") }}
    </router-link>
  </div>
</template>
<script>
import SatIcon from "@/components/Satellites/SatIcon.vue";
import { formatMixin } from "@/components/Satellites/format";

// Router list of a popover: emits `select` with a router id, or null for "no router".
export default {
  name: "RouterMenu",
  components: { SatIcon },
  mixins: [formatMixin],
  props: {
    routers: {
      type: Array,
      required: true,
    },
    // Current router id, undefined when several domains with different routers are edited
    value: {
      type: String,
      default: undefined,
    },
    allowNone: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return { query: "" };
  },
  computed: {
    filtered() {
      const query = this.query.toLowerCase();
      return query ? this.routers.filter((router) => router.name.toLowerCase().includes(query)) : this.routers;
    },
  },
  mounted() {
    if (this.$refs.search) this.$refs.search.focus();
  },
  methods: {
    pickFirst() {
      if (this.filtered.length) this.$emit("select", this.filtered[0].id);
    },
  },
};
</script>
<style lang="scss" scoped>
.router-menu__search {
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 2px 2px 4px;
  padding: 0 10px;
  border-radius: 8px;
  color: var(--sat-muted);
  background: var(--sat-input);

  input {
    flex: 1;
    height: 36px;
    padding: 0;
    border: 0 !important;
    font-size: 14px;
    background: transparent !important;
  }
}

.router-menu__name {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.router-menu__empty {
  padding: 8px 10px;
  font-size: 13px;
  color: var(--sat-muted);
}
</style>
